module.exports = __webpack_public_path__ + "media/images/pic/certificates/about-us/big/brc-global-en-bdd3d14996af8beedb4a29ec18f7cd64.jpg";